module.exports = "<div class=\"noResultsFoundMessage\">No suggestions found.</div>"